import { useState, useEffect } from 'react';
import {Tools} from "../../ExternalTools/tools.tsx";
import AutoScrollingGallery from "./Components/AutoScrollingGallery.tsx";
import { Helmet } from 'react-helmet-async';
import { Config } from '../../config.tsx';
import { NewsItem } from '../News/Models/NewsModels.tsx';

export const Home = () => {
    const saldoColored = Tools.GenerateRandomLettersColorsJSX("Twoje Biuro Rachunkowe!")
    const polecajanasColored = Tools.GenerateRandomLettersColorsJSX("Polecają nas!")
    const newsColored = Tools.GenerateRandomLettersColorsJSX("Aktualności")
    const workYears = new Date().getFullYear() - 2010

    const [latestNews, setLatestNews] = useState<NewsItem[]>([]);

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const response = await fetch(`${Config.API_URL}/news`);
                if (!response.ok) return;
                const data: NewsItem[] = await response.json();
                data.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
                setLatestNews(data.slice(0, 3));
            } catch (error) {
                console.error('Błąd podczas pobierania newsów:', error);
            }
        };
        fetchNews();
    }, []);

    return (
<>
    <Helmet>
        <title>Biuro rachunkowe Saldo.pl | Profesjonalne usługi księgowe Cieszyn</title>
        <meta name="description" content="Biuro rachunkowe Saldo.pl oferuje kompleksowe usługi księgowe dla firm w Cieszynie i okolicach. Ponad 15 lat doświadczenia w obsłudze księgowej przedsiębiorstw." />
        <meta name="keywords" content="biuro rachunkowe Cieszyn, księgowa, księgowość firm, rozliczenia podatkowe, Saldo.pl, usługi księgowe Cieszyn" />
        <link rel="canonical" href="https://podatki-saldo.pl/" />
        <meta property="og:title" content="Biuro rachunkowe Saldo.pl | Profesjonalne usługi księgowe" />
        <meta property="og:description" content="Profesjonalne usługi księgowe dla firm w Cieszynie i okolicach. Skontaktuj się i poznaj naszą ofertę." />
        <meta property="og:url" content="https://podatki-saldo.pl/" />
        <meta property="og:type" content="website" />
    </Helmet>
    <div className="main-content">
    <div className="home-introduction">
        <div className="introduction-header">
            <h1>
                <span className="saldo-animated rochester-regular">
                    "Saldo.pl"
                    <div className="saldo-animated-mask"></div>
                </span>
                <span className=" tax-office-text opacity-animated-1">
                    <span>{saldoColored}</span>
                </span>

            </h1>
        </div>

        <div className="introduction-description">

            <div className="introduction-text-1">
                {/*<div className="introduction-text-1-left-rectangle"></div>*/}
                <p>Przez ponad {workYears} lat firma jest synonimem profesjonalizmu w świecie finansów, przekształcając skomplikowane wyzwania podatkowe w klarowne, precyzyjne rozwiązania. Zespół certyfikowanych księgowych, wyposażony w najnowocześniejsze narzędzia i nieprzerwanie aktualizowaną wiedzę podatkową, gwarantuje nie tylko bezbłędne rozliczenia, ale przede wszystkim spokój i bezpieczeństwo finansowe. Każdego klienta traktuje się indywidualnie, łącząc wieloletnie doświadczenie z innowacyjnym podejściem-firma stała się zaufanym partnerem dla setek przedsiębiorców, którym zależy na rzetelności, terminowości i profesjonalizmie. Czy finanse są gotowe na kompleksową, profesjonalną opiekę?</p></div>
            <div className="introductio-image-1 none-select">
                {/*<div className="introduction-image-1-right-rectangle"></div>*/}
                <img src="/images/saldo_gate.jpg" alt="firma w całej okazałości" width="500"></img>
            </div>
        </div>
    </div>

        <div className="home-news">
            <h2>{newsColored}</h2>
            {latestNews.length > 0 ? (
            <div className="home-news-grid">
                {latestNews.map((news, index) => (
                    <div key={index} className="home-news-card">
                        <div className="home-news-date">
                            {new Date(news.date).toLocaleDateString('pl-PL', {
                                year: 'numeric', month: 'long', day: 'numeric'
                            })}
                        </div>
                        <h3 className="home-news-header">{news.header}</h3>
                        <p className="home-news-description">{news.description}</p>
                        <a href="/news" className="home-news-link">Czytaj więcej</a>
                    </div>
                ))}
            </div>
            ) : (
                <p className="home-news-empty">...</p>
            )}
        </div>

    
    <div className="home-stats">
        {/*<h2>*/}
        {/*    Statystyki*/}
        {/*</h2>*/}
        <div className="stats-grid-container none-select">
            <div className="stats-grid-item">
                <div>{workYears}+</div>
                <div>Lat na rynku</div>
            </div>
            <div className="stats-grid-item">
                <div>500+</div>
                <div>Zadowolonych klientów</div>
            </div>
        </div>
    </div>

    <div className="home-recomendations none-select">
        <h2>
            {polecajanasColored}
        </h2>
        <AutoScrollingGallery></AutoScrollingGallery>
    </div>

    <div className="home-others">
        {/* <h2>Opinie innych o nas</h2> */}
        <div className="home-other-item">
           <iframe width="768" height="433" src="https://www.youtube.com/embed/0NzqpgdPpo8" title="Biuro Rachunkowe SALDO.PL sp. z o.o. sp.k. - Biura-Rachunkowe.waw.pl" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>
    </div>

    <div className="home-contact">
        <div className="home-contact-item"><img src="/icons/phone-call.png" width="30"/><a href="tel:+48513010265">+48 513 010 265</a></div>
        <div className="home-contact-item"><img src="/icons/phone-call.png" width="30"/><a href="tel:+48334761940">+48 (33) 476 19 40</a></div>
        <div className="home-contact-item"><img src="/icons/mail.png" width="30"/><a href="mailto:biuro@podatki-saldo.pl">biuro@podatki-saldo.pl</a></div>
    </div>
</div>
    </>
    )
}
